module.exports = __webpack_public_path__ + "img/33.48b01ca4.gif";